// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".release-notes-content[data-v-44bff274] {\n  max-height: 40em;\n  overflow-y: scroll;\n}\n\n/* width */\n[data-v-44bff274]::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* Track */\n[data-v-44bff274]::-webkit-scrollbar-track {\n  border-radius: 10px;\n}\n\n/* Handle */\n[data-v-44bff274]::-webkit-scrollbar-thumb {\n  background: grey;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n[data-v-44bff274]::-webkit-scrollbar-thumb:hover {\n  background: darkgray;\n}", ""]);
// Exports
module.exports = exports;
